import React, { useEffect, useState } from 'react';
import azureDevOpsService from './services/azureDevOpsService';
import { getSprintPeriods, getCurrentSprintIndex } from './utils/sprintUtils';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function KpiTestEfficiency() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const sprintStart = new Date('2025-11-05T00:00:00');
      const sprintStartNumber = 23;
      const currentSprintIndex = getCurrentSprintIndex(sprintStart);
      const firstSprintIndex = Math.max(0, currentSprintIndex - 7);
      const sprints = getSprintPeriods(sprintStart, firstSprintIndex, 8, sprintStartNumber);
      
      // Récupérer les bugs TA (même données que KPI "Bugs trouvés par sprint")
      const bugsTa = await azureDevOpsService.getBugsWithTA();
      // Récupérer tous les bugs avec regression
      const bugsRegression = await azureDevOpsService.getBugsWithRegression();
      
      console.log('Bugs TA:', bugsTa.length);
      console.log('Bugs avec regression:', bugsRegression.length);
      
      // Calculer l'efficacité par sprint
      const efficiencyData = sprints.map(sprint => {
        // Bugs TA dans ce sprint (tous, pas seulement ceux avec regression)
        const bugsTaInSprint = bugsTa.filter(bug => {
          const created = new Date(bug.creationDate);
          return created >= sprint.start && created <= sprint.end;
        });
        const bugsTaCount = bugsTaInSprint.length;
        
        // Total bugs regression dans ce sprint
        const bugsRegressionInSprint = bugsRegression.filter(bug => {
          const created = new Date(bug.creationDate);
          return created >= sprint.start && created <= sprint.end;
        });
        const totalRegression = bugsRegressionInSprint.length;
        
        // Efficacité = (bugs TA / bugs regression) × 100
        const efficiency = totalRegression > 0 ? (bugsTaCount / totalRegression) * 100 : 0;
        
        return {
          sprint: sprint.name,
          efficiency: Math.round(efficiency * 100) / 100,
          bugsTaCount,
          totalRegression,
        };
      });
      
      console.log('Données efficacité:', efficiencyData);
      
      setChartData({
        labels: efficiencyData.map(row => row.sprint),
        datasets: [
          {
            label: 'Bugs TA',
            data: efficiencyData.map(row => row.bugsTaCount),
            backgroundColor: 'rgba(59,130,246,0.7)',
            yAxisID: 'y',
          },
          {
            label: 'Bugs Regression',
            data: efficiencyData.map(row => row.totalRegression),
            backgroundColor: 'rgba(239,68,68,0.7)',
            yAxisID: 'y',
          },
          {
            label: 'Efficacité TA (%)',
            data: efficiencyData.map(row => row.efficiency),
            backgroundColor: 'rgba(34,197,94,0.7)',
            yAxisID: 'y1',
          },
        ],
      });
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="bg-white rounded shadow p-6">
      <h2 className="text-lg font-bold mb-4">Efficacité des tests automatisés</h2>
      {loading || !chartData ? (
        <div>Chargement...</div>
      ) : (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            interaction: {
              mode: 'index',
              intersect: false,
            },
            plugins: {
              legend: { position: 'top' },
              title: {
                display: true,
                text: 'Efficacité = (Bugs TA / Bugs Regression) × 100',
              },
            },
            scales: {
              x: { title: { display: true, text: 'Sprint' } },
              y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: { display: true, text: 'Nombre de bugs' },
                beginAtZero: true,
              },
              y1: {
                type: 'linear',
                display: true,
                position: 'right',
                title: { display: true, text: 'Efficacité (%)' },
                beginAtZero: true,
                max: 100,
                grid: {
                  drawOnChartArea: false,
                },
              },
            },
          }}
        />
      )}
    </div>
  );
}
